export const DSC_LOGO_SRC = "/assets/dsc-logo.png";
export const SMS_TU_LOGO_SRC = "/assets/sms-tu-logo.png";
export const GROUP_PHOTO = "/assets/logo reveal group.jpg";